import i18next from "i18next";
import { lazy } from "react";
import bg from "./i18n/bg";
import en from "./i18n/en";

i18next.addResourceBundle("bg", "problemsPage", bg);
i18next.addResourceBundle("en", "problemsPage", en);

const TechSupport = lazy(() => import("./TechSupportDashboard"));

/**
 * The Problems page config.
 */
const ProblemsConfig = {
  settings: {
    layout: {},
  },
  auth: ["Godfather", "Admin", "Reception", "Main Cleaner", "Tech Support"],
  routes: [
    {
      path: "maintenance",
      element: <TechSupport />,
    },
  ],
};

export default ProblemsConfig;
